export default import.meta.ROLLDOWN_FILE_URL_$J2gHE0yBJs0Ivd69ncEuA